module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie H4 is a html <code>&lt;h4&gt;</code> text element</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;H4&gt;Your title goes here&lt;/H4&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/H4/README.md
// module id = 355
// module chunks = 0